import type { ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgInvitePeopleUrl from '@/assets/misc/img_invite-people.svg'
import InviteUsersIllustration from '@/components/SpotIllustration/InviteUsersIllustration'

export interface OCRConfirmSubmitDialogProps {
  showing: boolean
  isBillingRelevant: boolean
  billing: ReactNode
  isSubmitPending: boolean
  onClose: () => unknown
  onConfirm: () => unknown
}

export function OCRConfirmSubmitDialog({
  showing,
  isBillingRelevant,
  billing,
  isSubmitPending,
  onClose,
  onConfirm,
}: OCRConfirmSubmitDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSubmitPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgInvitePeopleUrl}
            illustration={byDesign(undefined, InviteUsersIllustration)}
          />
          <ModalSheetContentTitle>
            You are about to submit an OCR job scope
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed? Once you submit you will no longer
            be able to make any more changes.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
        {isBillingRelevant && (
          <ModalSheetContentBlock>{billing}</ModalSheetContentBlock>
        )}
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            isDisabled={isSubmitPending}
            onPress={onClose}
          />
          <Button
            label="Submit"
            variant="primary"
            isPending={isSubmitPending}
            onPress={onConfirm}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
